import { defineMessages } from 'react-intl';

export default defineMessages({
	status: {
		id: 'components.walletPayment.itemModal.status',
		defaultMessage: 'وضعیت:',
	},
	confirmedAt: {
		id: 'components.walletPayment.itemModal.confirmedAt',
		defaultMessage: 'تاریخ تراکنش:',
	},
	traceId: {
		id: 'components.walletPayment.itemModal.traceId',
		defaultMessage: 'شماره پیگیری تراکنش:',
	},
	amount: {
		id: 'components.walletPayment.itemModal.amount',
		defaultMessage: 'مبلغ پرداخت شده مشتری:',
	},
	payedAt: {
		id: 'components.walletPayment.itemModal.payedAt',
		defaultMessage: 'تاریخ تسویه:',
	},
	settlementId: {
		id: 'components.walletPayment.itemModal.settlementId',
		defaultMessage: 'شماره پیگیری تسویه:',
	},
});
